import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import img from '../Assets/images.jpg';
import { API_URI } from "../Common/data";
import axios from "axios";
import { Helmet } from "react-helmet";
import Loader from "../loader/Loader";

function BlogDetail() {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const response = await axios.get(`${API_URI}/blog/byslug/${id}`); // Fetch single blog
        if (response.status === 200) {
          setBlog(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching blog:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBlog();
  }, [id]);
  if(loading) return <Loader />
  if (loading) return <p>Loading...</p>;
  if (!blog) return <p>Blog not found</p>;

  return (
    <>
      <Helmet>
        <title>
          {blog?.metaTitle && blog?.metaTitle.toLowerCase() !== "test title"
            ? blog?.metaTitle
            : blog?.title}
        </title>

        <meta
          name="title"
          content={
            blog?.metaTitle && blog?.metaTitle.toLowerCase() !== "test title"
              ? blog?.metaTitle
              : blog?.title
          }
        />

        <meta
          name="description"
          content={
            blog?.metaDescription &&
              blog?.metaDescription.toLowerCase() !== "test description"
              ? blog?.metaDescription
              : blog?.content?.replace(/<[^>]+>/g, "").substring(0, 160)
          }
        />

        <meta
          name="keywords"
          content={
            blog?.metaKeywords && Array.isArray(blog?.metaKeywords)
              ? blog?.metaKeywords.join(", ")
              : "Cine Celebrate, Blogs"
          }
        />

        {/* Canonical */}
        <link
          rel="canonical"
          href={`${window.location.origin}/blog/${blog?.slug || blog?._id}`}
        />

        {/* Open Graph */}
        <meta property="og:type" content="article" />
        <meta property="og:title" content={blog?.metaTitle || blog?.title} />
        <meta
          property="og:description"
          content={
            blog?.metaDescription ||
            blog?.content?.replace(/<[^>]+>/g, "").substring(0, 160)
          }
        />
        <meta
          property="og:image"
          content={blog?.displayImage || img}
        />
      </Helmet>
      <Navbar />
      {/* <div className='news-banner'>
        <p>Blog Detail</p>
        <br/>
        <h3>Blog Detail</h3>

        </div> */}
      <section className="blog-detail-hero">
        <div className="blog-detail-hero__inner">
          <div className="blog-detail-hero__copy">
            <p className="blog-detail-hero__eyebrow">Cine Celebrate Journal</p>
            <h1>{blog?.title || "What Is a Business Writing Blog?"}</h1>
            <p className="blog-detail-hero__lede">
              {(blog?.metaDescription && blog.metaDescription.toLowerCase() !== "test description"
                ? blog.metaDescription
                : blog?.content?.replace(/<[^>]+>/g, "").substring(0, 220)) || ""}
            </p>
            <div className="blog-detail-hero__meta">
              <div className="blog-detail-hero__meta-card">
                <span>Type</span>
                <strong>Blog Article</strong>
              </div>
              <div className="blog-detail-hero__meta-card">
                <span>Reading flow</span>
                <strong>Editorial view</strong>
              </div>
            </div>
          </div>
          <div className="blog-detail-hero__media">
            <img src={blog?.displayImage || img} alt={blog?.title || "Blog cover"} />
          </div>
        </div>
      </section>

      <div className='BlogDetail blog-detail-revamp'>
        <div className="blog-detail-revamp__hero">
          <div className="blog-detail-revamp__intro">
            <p className="blog-detail-revamp__eyebrow">Article</p>
            <h2>{blog?.title || "What Is a Business Writing Blog?"}</h2>
          </div>
        </div>
        <div className="blog-detail-revamp__content">
          <div className="danget-html-content" dangerouslySetInnerHTML={{__html: blog?.content}} />
        </div>
        {/* <p>
          {blog?.content || `Business blog is one of the best ways to promote ones business with
          minimum expenses. Modern technologies have supported this way of
          business promotion and now business blog writing has become the basic
          tool for increasing the profit by means of attracting customers,
          driving traffic, and increasing sales. Unfortunately, not many people
          have managed understand the effectiveness of business blog writing and
          continue avoiding its advantages or using them in a wrong way.
          Blogging has become one of the ways for expressing personal thoughts.
          Business people can deliver their messages to the target audience
          using business blog writing. Effective key words and tags can assist
          in driving the traffic and increasing the number of visits, which is a
          part of guarantee of business success.`}
        </p> */}
        {/* <br />
        <br />
        <h3>How to Blog for Business</h3>
        <br />
        <p>
          Business blog is one of the best ways to promote ones business with
          minimum expenses. Modern technologies have supported this way of
          business promotion and now business blog writing has become the basic
          tool for increasing the profit by means of attracting customers,
          driving traffic, and increasing sales. Unfortunately, not many people
          have managed understand the effectiveness of business blog writing and
          continue avoiding its advantages or using them in a wrong way.
          Blogging has become one of the ways for expressing personal thoughts.
          Business people can deliver their messages to the target audience
          using business blog writing. Effective key words and tags can assist
          in driving the traffic and increasing the number of visits, which is a
          part of guarantee of business success.
        </p>
        <br />
        <h3>5 Mistakes in Business Blog Writing</h3>
        <br />

        <ul>
          <li>
            A boring blog with the information understandable for the business
            people only.
          </li>
          <li>
            A very long post with much terminology and numerous ideas, which
            seem related to the problem, but do not coincide effectively in one
            post.
          </li>
          <li>Too frequent or too rare posts.</li>
          <li>Irrelevant keywords.</li>
          <li>
            Failure to wait for the results and leaving a blog unattended.
          </li>
        </ul> */}
      </div>
      <Footer />
    </>
  );
}

export default BlogDetail;
